import { defineComponent as _defineComponent } from 'vue'
import { Ref, nextTick, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
    src: null,
    hasFill: { type: Boolean, default: false },
    growByHeight: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { src: string, hasFill: boolean, growByHeight: boolean };



const svgContent: Ref<string | null> = ref(null);
const currentElRef: Ref<HTMLElement | null> = ref(null);

onMounted(async () => {
    await nextTick();
    const response = await fetch(props.src);
    svgContent.value = await response.text();
    await nextTick();
    buildSvg();
});

const recursivelyRemoveFill = (el: Element) => {
    if (!el) {
        return;
    }

    el.removeAttribute('fill');
    [].forEach.call(el.children, (child) => {
        recursivelyRemoveFill(child);
    });
};

const buildSvg = () => {
    const svgElement = currentElRef.value?.firstElementChild;
    if (svgElement && svgElement.nodeName === 'svg') {
        const viewBoxAttr = svgElement.getAttribute('viewBox');

        if (viewBoxAttr) {
            // Use `viewBox` attribute to get the svg's inherent width and height
            const viewBox = viewBoxAttr.split(' ').map((n) => Number(n));

            const widthToHeight = (viewBox[2] / viewBox[3]).toFixed(2);
            if (props.hasFill) {
                // Recursively remove all fill attribute of element and its nested children
                recursivelyRemoveFill(svgElement);
            }

            // Set width and height relative to font size if growByHeight is true, height set to 1em else width set to 1em and remaining is calculated based on widthToHeight ratio
            if (props.growByHeight) {
                svgElement.setAttribute('height', '1em');
                svgElement.setAttribute('width', `${widthToHeight}em`);
            } else {
                svgElement.setAttribute('width', '1em');
                svgElement.setAttribute('height', `${1 / Number(widthToHeight)}em`);
            }
            svgElement.classList.add('svg-class');
        }
    }
};

return { __sfc: true,props, svgContent, currentElRef, recursivelyRemoveFill, buildSvg }
}

})